import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import NftCopy from "@/assets/svg/nft-copy.svg";
import { ReactSVG } from "react-svg";
import { useState } from "react";
import { useToastContext } from "@/contexts/ToastContext";
import {CopyToClipboard} from 'react-copy-to-clipboard';

import NftImg1 from '@/assets/imgs/nfts/1.jpg'
import NftImg2 from '@/assets/imgs/nfts/2.jpg'
import NftImg3 from '@/assets/imgs/nfts/3.jpg'
import NftImg4 from '@/assets/imgs/nfts/4.jpg'
import NftImg5 from '@/assets/imgs/nfts/5.jpg'
import NftImg6 from '@/assets/imgs/nfts/6.jpg'
import genieImage from '@/assets/imgs/nfts/genie.png'
import knightImage from '@/assets/imgs/nfts/knight.png'

import { NFTCA } from '@/utils/abi'
import { masacAddress } from '@/utils/index'

export default function Stake({ handleClose, item }) {

  const { showToast } = useToastContext();
  const onCopy = ()=>{
    showToast({
      dir:'top',
      type:'success',
      text:'Copied!'
    })
  }
  
  return (
    <Modal>      
      <div className='close' onClick={handleClose}><ReactSVG src={CloseImg}/></div>
      <div className="content">        
        <div className="main-title">My Squad</div>
        <div className="line"></div>
        <div className="inner">
          <div className="inner-left">
            <div className="inner-title">{item?.info?.name || 'King of Combat'} <span className="id">#{item.tokenId}</span></div>
            <div className="line-wrapper">
              <div className="line-item-left">
                <span className="line-item-span">Owner </span>
                <span className="line-item-span">Contract Address </span>
                <span className="line-item-span">Token id</span>
                <span className="line-item-span">Asset Protocol</span>
                <span className="line-item-span">Asset Public Chain</span>
              </div>
              <div className="line-item-right-block">
                <div className="line-item-span copy-line">
                  <CopyToClipboard text={item.address} onCopy={onCopy}>
                    <div>{masacAddress(item.address)}</div>
                  </CopyToClipboard>                  
                  <ReactSVG className="nft-copy-svg" src={NftCopy} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
                </div>
                <div className="line-item-span copy-line">
                  <CopyToClipboard text={item.contractAddres || NFTCA} onCopy={onCopy}>
                  <div>{masacAddress(item.contractAddres || NFTCA)}</div>
                  </CopyToClipboard>                  
                  <ReactSVG className="nft-copy-svg" src={NftCopy} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
                  </div>
                <div className="line-item-span" style={{'color':'#32DE86'}}>{item.tokenId}</div>                
                <div className="line-item-span">ERC721</div>
                <div className="line-item-span">Arbitrum</div>
              </div> 
            </div>
                       
          </div>
          <div className="inner-right">
            {/* <img className="nft-img" src={NftImg1} alt="" /> */}

            <img className='nft-img' src={
              item.type === 1 ? NftImg1 : (
                item.type === 2 ? NftImg2 : (
                  item.type === 3 ? NftImg3 :(
                    item.type === 4 ? NftImg4 : (
                      item.type === 5 ? NftImg6 :
                        item.type === 6 ? NftImg5:
                          item.type === 7 ? genieImage : knightImage
                    )
                  )
                )
              )
              } alt="" />


          </div>
        </div>
      </div>
    </Modal>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .close {
    position: absolute;
    right: 44px;
    top: 40px;
    cursor: pointer;
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 40px;
    .main-title{
      width: 100%;
      font-weight: 600;
      text-align: left;
      font-size: 30px;
      line-height: 42px;
      padding-bottom: 20px;
      color: #32DE86;
    }
    .line{
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.15);
    }
    .inner{
      display: flex;
      padding-top: 20px;
      align-self: flex-start;
      .inner-right{
        margin-left: 80px;
        .nft-img{
          width: 408px;
          border-radius:20px;
        }
      }
      .inner-left {
        .inner-title{
          font-weight: 600;
          font-size: 40px;
          line-height: 56px;
          padding-bottom: 40px;
          color: #FFFFFF;
          .id{
            color: #32DE86;
            padding-left: 16px;
          }
        }
        .line-wrapper{
          display: flex;
        }
        .line-item-left{
          display: flex;
          flex-direction: column;
          width: 180px;
          .line-item-span{
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            color: rgba(255, 255, 255, 0.6);
            & + .line-item-span{
              padding-top: 30px;
            }
          }
          
        }
        .line-item-right-block{
          display: flex;
          flex-direction: column;
          padding-left: 63px;
          .line-item-span{
             font-weight: 600;
            font-size: 20px;
            line-height: 28px;
            & + .line-item-span{
              padding-top: 30px;
            }
          }
          .copy-line{
            display: flex;
            align-items: center;
            cursor: pointer;
            .nft-copy-svg{
             margin-left: 8px;
             margin-top: 2px;
            }
          }
        }
      }
    }
  }

  

`;
